export function isEmailValid(email?: string) {
    if (!email) {
        return false;
    }
    const pattern = /^\S{1,60}@{1}[a-z0-9_-]{1,60}(\.[a-z0-9_-]{2,60})+$/;
    return pattern.test(email);
}
